import React from 'react';
import { Layout } from '../components/layout/Layout';
import '../styles/sessions.css';

export const SessionsPage = () => {
  return (
    <Layout>
      <div className="sessions">
        <div className="page-header">
          <h1>Therapy Sessions</h1>
          <p>Create and manage therapy sessions</p>
        </div>

        <div className="sessions-container">
          <div className="session-card">
            <h3>Start New Session</h3>
            <p>Begin a therapy session with your selected deck</p>
            <button className="session-action-button">Start Session</button>
          </div>

          <div className="session-card">
            <h3>Active Sessions</h3>
            <p>Resume or view your ongoing sessions</p>
            <button className="session-action-button">View Active</button>
          </div>

          <div className="session-card">
            <h3>Session History</h3>
            <p>Review past session data and results</p>
            <button className="session-action-button">View History</button>
          </div>
        </div>
      </div>
    </Layout>
  );
};
